export const UserLabels = {
  heading: "Describe Yourself",
  bottom: "Select one to proceed to login",
};
